module.exports = __webpack_public_path__ + "static/button-bottom-94324b701eeea358092f48e7ba9b4081.png";